export const defaultCenter = {
  lat: 37.983810,
  lng: 23.727539
};

export const circleOptions = {
  strokeColor: '#FF0000',
  strokeOpacity: 0.8,
  strokeWeight: 1,
  fillColor: '#C64D45',
  fillOpacity: 0.5,
  clickable: false,
  draggable: false,
  editable: false,
  visible: true,
  radius: 300,
  zIndex: 1,
 
};